export class BrowserFeature {
	public static screenCapture (): boolean {
		return !!window.navigator?.mediaDevices?.getDisplayMedia;
	}
}
